import type { ICard } from "../cardsSlice";
import { wandsData } from "./minor/wands";
import { cupsData } from "./minor/cups";
import { swordsData } from "./minor/swords";
import { pentaclesData } from "./minor/pentacles";

export const minorArcanesData: ICard[] = [
  ...wandsData,
  ...cupsData,
  ...swordsData,
  ...pentaclesData,
];


